import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import { NavigationTabs } from '@/components/Common/NavigationTabs/NavigationTabs';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';

export default function SellerProductDirectory() {
  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={'Productos'}
        sx={{
          px: { xs: '16px', md: '0px' },
          pb: { xs: '0px', md: '16px' },
        }}
      />
      <NavigationTabs
        links={[
          {
            to: `/seller/products`,
            label: 'Todos',
          },
          {
            to: `/seller/products/active`,
            label: 'Publicados',
          },
          {
            to: `/seller/products/inactive`,
            label: 'Inactivos',
          },
        ]}
      />
    </TopLevelSectionLayout>
  );
}
